module.exports = __webpack_public_path__ + "static/media/avatar9.9e6532e6.jpg";